export default {
  methods: {
    formattedDate(date, format) {
      return this.$store.getters["language/formattedDate"]({
        date: date,
        format: format,
      });
    },
  },
};
